import { render } from "./StepsIndicator.vue?vue&type=template&id=0ba38b12&scoped=true"
import script from "./StepsIndicator.vue?vue&type=script&lang=js"
export * from "./StepsIndicator.vue?vue&type=script&lang=js"

import "./StepsIndicator.vue?vue&type=style&index=0&id=0ba38b12&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba38b12"]])

export default __exports__